import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import styles from './Layout.module.scss';

export const PureLayout = ({ children, title, description, data }) => {
  return (
    <div className={styles.layout}>
      {children}
    </div>
  );
};

export const Layout = props => (
  <StaticQuery
    query={graphql`
      query LayoutQuery {
        site {
          siteMetadata {
            url
            author {
              photoLarge
            }
          }
        }
      }
    `}
    render={data => <PureLayout {...props} data={data} />}
  />
);

export default Layout;
